module.exports = __webpack_public_path__ + "img/ET.6c1bd7db.svg";